import { NavLink } from "react-router-dom";
import {
  FaBuilding,
  FaBriefcaseMedical,
  FaPassport,
  FaCar,
  FaUtensils,
  FaShoppingBag,
} from "react-icons/fa";
import { TbDental } from "react-icons/tb";
import { IoFastFoodOutline } from "react-icons/io5";
import HouseIcon from "@mui/icons-material/House";
import ApartmentIcon from "@mui/icons-material/Apartment";
import MosqueIcon from "@mui/icons-material/Mosque";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import { AiOutlineMedicineBox } from "react-icons/ai";
import { IoHomeOutline } from "react-icons/io5";
import { PiBuildingApartmentLight, PiMosqueLight } from "react-icons/pi";
import { RiPassportLine } from "react-icons/ri";
import { IoCarSportOutline } from "react-icons/io5";
import { BsHouse } from "react-icons/bs";
import { FiExternalLink } from "react-icons/fi";

const links = [
  { name: "Home", path: "/", icon: <BsHouse /> },
  { name: "Apartments", path: "/apartments", icon: <PiBuildingApartmentLight /> },
  { name: "Medical", path: "/medical", icon: <AiOutlineMedicineBox /> },
  { name: "Visas", path: "/visas", icon: <RiPassportLine /> },
  { name: "Chauffeur", path: "/chauffeur", icon: <IoCarSportOutline /> },
  { name: "Dental", path: "/dental", icon: <TbDental /> },
  { name: "Contact us", path: "/contact-us", icon: <SupportAgentIcon /> },

];

const Menu = ({ mobile = false, onLinkClick = () => {} }) => {
  return (
    <nav
      className={`${
        mobile ? "flex flex-col gap-3" : "flex gap-5"
      } uppercase font-medium`}
    >
      {links.map(({ name, path, icon, external }) =>
        external ? (
          // 🔗 External link opens in new tab
          <a
            key={name}
            href={path}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-2 py-1 transition text-white hover:text-yellow-300 text-sm md:text-[8px] lg:text-xs tracking-wide"
            style={{ fontFamily: "rufina" }}
          >
            <span className="text-lg md:hidden lg:inline-flex items-center">
              {icon}
            </span>
            <span className="flex items-center gap-1">
              {name}
              <FiExternalLink className="text-[10px] ml-1" />
            </span>
          </a>
        ) : (
          // 🧭 Internal route
          <NavLink
            key={name}
            to={path}
            onClick={onLinkClick}
            className={({ isActive }) =>
              `flex items-center gap-2 px-2 py-1 transition ${
                isActive
                  ? "text-yellow-400"
                  : "text-white hover:text-yellow-300"
              } text-sm md:text-[8px] lg:text-xs tracking-wide`
            }
            style={{ fontFamily: "rufina" }}
          >
            <span className="text-lg md:hidden lg:inline-flex items-center">
              {icon}
            </span>
            <span>{name}</span>
          </NavLink>
        )
      )}
    </nav>
  );
};

export default Menu; // Make sure this export is at the end